import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'incidentType'
})
export class IncidentTypePipe implements PipeTransform {

  constructor() {

  }

  transform(incidentType: string): string {
    if(incidentType == 'Offender' || incidentType == 'Offenders') { 
        return 'Responsible';  // ONE-7360 Changed from Offender to Responsible
    }
    else {
        return incidentType;
    }
  }

}
